export enum EDatePresets {
  ALL = 'all',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}
